import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
// Correct import for Swiper v9+
import { Autoplay, Pagination, Navigation } from 'swiper'; // <--- CHANGE THIS LINE BACK
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const ImageSlider = () => {
  const images = [
    { id: 1, src: 'https://lbfdqhi.asninstitute.id/file-banner/New Banner Platform.png', alt: 'Selamat Datang' },
    { id: 2, src: 'https://lbfdqhi.asninstitute.id/file-banner/New Banner Platform.png', alt: 'Selamat Datang' },
  ];

  return (
    <CardBody>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation={true}
        // Ensure modules are passed correctly
        modules={[Autoplay, Pagination, Navigation]} // <--- KEEP THIS LINE AS IS
        className="mySwiper"
        style={{ height: '100%', borderRadius: '5px' }}
      >
        {images.map(image => (
          <SwiperSlide key={image.id}>
            <img
              src={image.src}
              alt={image.alt}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </CardBody>
  );
};

export default ImageSlider;